module.exports = __webpack_public_path__ + "static/media/img_banner.2a464ae9.jpg";